<template>
    <ul class="navi-group">
        <li class="navi-item nav-heading rounded">Service</li>
        <li class="nav-item" @click="toggleMenu"><a target="_blank" class="nav-link" href="https://cdn.mietmeile.de/images/index/Mietmeile_Leitfaden_OptimalesInserat.pdf">Das optimale Inserat (pdf)</a></li>
        <li class="nav-item" @click="toggleMenu"><a target="_blank" class="nav-link" href="https://cdn.mietmeile.de/images/index/Mietvertrag_Mietmeile.pdf">Mietvertrag (pdf)</a></li>
   </ul>
</template>

<script>
    import { ToggleMenuMixin } from '../../../mixins/ToggleMenu';

    export default {
        mixins: [ToggleMenuMixin]
    }
</script>

<style scoped>

</style>
